export default __webpack_public_path__ + "static/media/btn_str_gift_ban.fb04b69e.svg";